import { convertUtcToLocalDate } from 'library/time';
import { formatTags } from './tag.selectors';

export const formatLeaveItem = (item = {}) => ({
  ...item,
  start_datetime: item.start_datetime ? convertUtcToLocalDate(item.start_datetime) : item.start_datetime,
  end_datetime: item.end_datetime ? convertUtcToLocalDate(item.end_datetime) : item.end_datetime,
  requested_date: item.requested_date ? convertUtcToLocalDate(item.requested_date) : item.requested_date,
  itemTags: item.itemTags.length ? formatTags(item.itemTags) : [],
  sap_change_date: item.sap_change_date ? convertUtcToLocalDate(item.sap_change_date) : item.sap_change_date
});

export const formatLeaveList = (list = []) => list.map(item => ({
  ...item,
  type__name: item.type.name,
  status__name: item.status.name,
  start_datetime: convertUtcToLocalDate(item.start_datetime),
  end_datetime: convertUtcToLocalDate(item.end_datetime),
  requested_date: convertUtcToLocalDate(item.requested_date)
}));
